/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_PlaceholderInputs */



/**
* | output |
* | --- |
* | "00:00:00:00" |
*
* @param {Timecode_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_placeholder = /** @type {((inputs?: Timecode_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "de") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "it") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "ru") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "es") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "ja") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "hi") return /** @type {LocalizedString} */ ("00:00:00:00")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("00:00:00:00")
	return /** @type {LocalizedString} */ ("00:00:00:00")
});